import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/new-arrivals/FeaturedSection.tsx");
